import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import type { PublicationItemInfo } from "./useTaskDetailSubscription";
import { IndexingBadge } from "../../ui/IndexingBadge";
import { PUBLICATION_ITEM_STATUS_COLORS } from "./ArticleVariations";
import type { SentenceInfo } from "./AnchorsSection";

export function SentenceBand(props: {
  sentence: SentenceInfo;
  publicationItems: PublicationItemInfo[] | null;
  colSpan: number;
}) {
  const { sentence } = props;
  const item = props.publicationItems
    ? props.publicationItems.find((publicationItem) => publicationItem.anchorSentenceId === sentence.id)
    : undefined;

  return (
    <TableRow>
      <TableCell
        colSpan={props.colSpan}
        sx={{ pt: 0.5, pb: 1, pl: 4, pr: 2, borderBottom: "none" }}
      >
        <Box
          bgcolor="action.hover"
          borderRadius={1}
          px={1.5}
          py={1}
          display="flex"
          flexDirection="column"
          gap={0.75}
        >
          <Box
            sx={{ "& p:first-of-type": { mt: 0 }, "& p:last-of-type": { mb: 0 } }}
            dangerouslySetInnerHTML={{ __html: sentence.html }}
          />
          {item ? (
            <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
              <Typography variant="caption" color="text.secondary">
                Сайт: {item.siteUrl}
              </Typography>
              <Chip
                label={item.status}
                size="small"
                color={PUBLICATION_ITEM_STATUS_COLORS[item.status]}
              />
              {item.publishedUrl && (
                <Link
                  href={item.publishedUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="caption"
                >
                  {item.publishedUrl}
                </Link>
              )}
              <Typography variant="caption" color="text.secondary" component="span">
                Индексация: <IndexingBadge aggregate={item.indexing} />
              </Typography>
            </Box>
          ) : (
            props.publicationItems !== null && (
              <Typography variant="caption" color="text.secondary">
                Не размещено
              </Typography>
            )
          )}
        </Box>
      </TableCell>
    </TableRow>
  );
}
